var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicropiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 7.500083, 40.17784)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000110943 1.002464 L 39.999892 1.002464 ",
    stroke: "#000000",
    strokeWidth: 2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000046, -0.754839, 0.75, 0.000000000000000046, 35.999999, 65.624994)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 1.997521 2.000002 L 75.502471 2.000002 ",
    stroke: "#000000",
    strokeWidth: 4,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.573241, 0.475604, -0.478891, 0.577203, 38.233907, 30.311215)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.00022 2.001793 L 50.360764 2.000971 ",
    stroke: "#000000",
    strokeWidth: 4,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.573241, 0.475604, -0.478891, 0.577203, 38.233907, 13.746116)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 1.999099 2.000451 L 50.359644 1.999629 ",
    stroke: "#000000",
    strokeWidth: 4,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicropiles);
export default __webpack_public_path__ + "static/media/Micropiles.4de933a371e86c562cc5205ad3734e37.svg";
export { ForwardRef as ReactComponent };